import { inject, Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslationService } from '../services';
import { LANGUAGE_HEADER_ENABLED } from './language-header.context';

/**
 * HTTP Interceptor to add Accept-Language header to requests
 * it uses TranslationService to get the current language
 * and this way ensures the backend receives the correct language preference
 */

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  private _injector = inject(Injector);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.context.get(LANGUAGE_HEADER_ENABLED))
      return next.handle(req);

    const lang = this._injector.get(TranslationService).selectedLanguage() || 'es';
    const modifiedReq = req.clone({
      setHeaders: {
        'Accept-Language': lang
      }
    });
    return next.handle(modifiedReq);
  }
}